/**
 * Chaves canônicas dos filtros rápidos da lista de conversas (estado + API em PT).
 * A UI traduz via i18n usando `chatList.filters.<key>`.
 */
export const CHAT_QUICK_FILTER_TO_I18N = {
  "Minhas Solicitações": "mine",
  "Outros Usuários": "otherUsers",
  Fila: "queue",
  ChatBots: "chatbots",
  "Agentes de IA": "aiAgents",
  "Não Lidas": "unread",
  Pendente: "pending",
  "Em Atendimento": "inProgress",
  "Contato Futuro": "futureContact",
  Concluída: "done",
  Perdida: "lost",
  Cancelada: "canceled",
};

export function translateQuickFilterLabel(filter, tChatList) {
  const id = CHAT_QUICK_FILTER_TO_I18N[filter];
  if (!id) return filter;
  return tChatList(`filters.${id}`);
}
